import { render } from "./AppFooterSSK.vue?vue&type=template&id=64c4318e"
import script from "./AppFooterSSK.vue?vue&type=script&lang=js"
export * from "./AppFooterSSK.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__